module.exports = __webpack_public_path__ + "static/media/wallpaperGradient.ea7d7686.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallpaperGradient.png
// module id = 7
// module chunks = 0